export const simplifyFileName = (filename?: string): string => {
  if (typeof filename !== 'string') {
    return '';
  }

  if (filename.endsWith('.')) {
    //eslint-disable-next-line no-param-reassign
    filename = filename.slice(0, filename.length - 1);
  }

  //Catch part filenames such as `<filename>.prt.<version_number>`
  const matchFileNameWithEndingNumbers = filename.match(/(.+?)(\.\d+)$/);
  if (matchFileNameWithEndingNumbers) {
    //eslint-disable-next-line no-param-reassign
    filename = matchFileNameWithEndingNumbers[1];
  }

  // Remove the file extension from filename
  // (captures everything except the last dot and file extension)
  // Reference: https://www.movingtofreedom.org/2008/04/01/regex-match-filename-base-and-extension/
  const matches = filename.match(/(.+?)(\.[^.]*$|$)/);
  return matches ? matches[1] : filename;
};
